import { Model } from "./Model";

export interface Sponsor extends Model {
	contactEmail: string;
	contactName: string;
	contactNumber: string;
	imageDark: string;
	imageLight: string;
	imagePartner: string;
	name: string;
}

export class Sponsor implements Sponsor {

	constructor(data?: Partial<Sponsor>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}